document.addEventListener('turbolinks:load', function () {

  $('.staff_slideup_btn, .parent_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.staff_slide_flag, .parent_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.staff_slidedown_btn, .parent_slidedown_btn').fadeIn(0));
  });

  $('.staff_slidedown_btn, .parent_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.staff_slide_flag, .parent_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.staff_slideup_btn, .parent_slideup_btn').fadeIn(0));
  });

  $('#create_staff_submit_btn').on('click', function () {
    let staff_name = $('#staff_name').val();
    let staff_ugc_name = $('#staff_ugc_name').val();
    let staff_login_id = $('#staff_login_id').val();
    let staff_login_password = $('#staff_login_password').val();
    let staff_group_name = $('#staff_group_name').val();
    let staff_remark = $('#staff_remark').val();

    if (!staff_name &&
        !staff_ugc_name &&
        !staff_login_id &&
        !staff_login_password) {
      alert("必須箇所を入力してください。");
      return;
    }

    $.ajax({
      url: '/create_staff',
      type: 'POST',
      data: {
        staff_name: staff_name,
        staff_ugc_name: staff_ugc_name,
        staff_login_id: staff_login_id,
        staff_login_password: staff_login_password,
        staff_group_name: staff_group_name,
        staff_remark: staff_remark,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  $('.staff_edit').on('click', function () {
    let staff_id = $(this).data("id");
    let staff_name = $(this).data("name");
    let staff_ugc_name = $(this).data("ugc_name");
    let staff_login_id = $(this).data("staff_login_id");
    let staff_login_password = $(this).data("staff_login_password");
    let staff_group_name = $(this).data("group_name");
    let staff_remark = $(this).data("remarks");

    $("#staff_edit_id").val(staff_id);
    $("#staff_edit_name").val(staff_name);
    $("#staff_edit_ugc_name").val(staff_ugc_name);
    $("#staff_edit_login_id").val(staff_login_id);
    $("#staff_edit_login_password").val(staff_login_password);
    $("#staff_edit_group_name").val(staff_group_name);
    $("#staff_edit_remark").val(staff_remark);
  });

  $('#update_staff_submit_btn').on('click', function () {
    let staff_id = $('#staff_edit_id').val();
    let staff_name = $('#staff_edit_name').val();
    let staff_ugc_name = $('#staff_edit_ugc_name').val();
    let staff_login_id = $('#staff_edit_login_id').val();
    let staff_login_password = $('#staff_edit_login_password').val();
    let staff_group_name = $('#staff_edit_group_name').val();
    let staff_remark = $('#staff_edit_remark').val();

    if (!staff_name &&
        !staff_ugc_name &&
        !staff_login_id &&
        !staff_login_password) {
      alert("必須箇所を入力してください。");
      return;
    }

    $.ajax({
      url: '/update_staff',
      type: 'POST',
      data: {
        staff_id: staff_id,
        staff_name: staff_name,
        staff_ugc_name: staff_ugc_name,
        staff_login_id: staff_login_id,
        staff_login_password: staff_login_password,
        staff_group_name: staff_group_name,
        staff_remark: staff_remark,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  $('.staff_active, .staff_non_active').on('click', function () {
    let staff_id = $(this).data("id");
    let staff_is_active = $(this).data("is_active");

    $.ajax({
      url: '/update_staff_active',
      type: 'POST',
      data: {
        staff_id: staff_id,
        staff_is_active: staff_is_active
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  $('.staff_list_select_box').on('change', function () {
    let staff_id = $('.staff_list_select_box option:selected').val();

    window.location.href = window.location.pathname + '?staff_id=' + encodeURIComponent(staff_id);
  });

  let firstChecked = false;

  $('.staff_media_check').on('change', function() {
    if ($(this).is(':checked') && !firstChecked) {
      let caption = $(this).data('caption');
      $('#staff_post_submit').attr('data-caption', caption); // attrメソッドで属性を設定
      firstChecked = true;
    }

    // すべてのチェックボックスが未チェックの場合、フラグをリセット
    if (!$('.staff_media_check:checked').length) {
      firstChecked = false;
      $('#staff_post_submit').attr('data-caption', ''); // データキャプションをクリア
    }
  });

  $('.staff_post_submit').on('click', function () {
    let staff_id = $('.staff_list_select_box option:selected').val();
    let s3_staff_img_url = [];
    let caption = $(this).data('caption');

    $('.staff_media_check:checked').each(function () {
      s3_staff_img_url.push($(this).data("url"));
    });
    if (s3_staff_img_url.length == 0) {
      alert('画像を選択してください。');
      return;
    }

    $.ajax({
      url: '/create_staff_posts',
      type: 'POST',
      data: {
        staff_id: staff_id,
        img_urls: s3_staff_img_url,
        caption: caption
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('登録が完了しました。左メニューの手動投稿管理でご確認ください。');
        location.reload();
      }
    });
  });

  // #########################################################################
  // staffログイン画面
  $('#staff_login').on('click', function () {

    let company_login_id = $('#company_login_id').val();
    let staff_login_id = $('#staff_login_id').val();
    let staff_login_password = $('#staff_login_password').val();

    if (!staff_login_id || !staff_login_password) {
      return;
    }

    $.ajax({
      url: '/staff_manage/create_staff_session',
      type: 'GET',
      data: {
        company_login_id: company_login_id,
        staff_login_id: staff_login_id,
        staff_login_password: staff_login_password,
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 2) {
          location.href = '/staff_manage/index';
        } else {
          alert('ログインIDまたはパスワードが違います');
          location.reload();
        }
      });
  });

  $('#file-upload').on('change', function() {
    let files = $(this)[0].files;
    if (files.length > 0) {
      
      $(".staff_media_caption").css("display", "block");
      
      // 選択されたファイルの名前を表示する
      $.each(files, function(index, file) {
        console.log('選択されたファイル:', file.name);
      });
    }
  });

  $('#staff_media_upload_form').on('submit', function(e) {
    e.preventDefault(); // フォームのデフォルト送信処理を阻止

    let formData = new FormData(this); // フォームデータを取得
    let caption = $('.staff_media_caption').val(); // テキストエリアの値を取得
    formData.append('caption', caption); // テキストエリアの値をFormDataに追加

    let files = $('#file-upload')[0].files;
    let isValid = true;
    let errorMessage = '';

    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      if (file.type.match('image.*') && file.size > 1 * 1024 * 1024) {
        isValid = false;
        errorMessage += '画像ファイルは1MB以下である必要があります。\n';
      } else if (file.type.match('video.*') && file.size > 5 * 1024 * 1024) {
        isValid = false;
        errorMessage += '動画ファイルは5MB以下である必要があります。\n';
      }
    }

    if (!isValid) {
      alert(errorMessage);
      return;
    }

    $.ajax({
      url: '/staff_manage/upload_staff_media',
      type: 'POST',
      data: formData,
      processData: false, // jQueryがデータを処理しないように指定
      contentType: false, // jQueryがcontentTypeを設定しないように指定
      success: function(data) {
        console.log('Upload successful!');
        location.reload();
      },
      error: function(xhr, status, error) {
        console.error('Upload failed:', error);
        // ここにエラー時の処理を記述
      }
    });
  });

  $('.staff_logout').on('click', function () {
    $.ajax({
      url: '/staff_manage/staff_logout',
      type: 'GET',
      data: {},
      dataType: 'json',
    })
      .done(function (data) {
        location.reload();
      });
  });

  $('.display_sns_post_caption').on('click', function () {

    let sns_post_caption = $(this).data("caption");
    sns_post_caption = sns_post_caption.replace(/\n/g, '<br>');

    if (!sns_post_caption) {
      sns_post_caption = ""
    }

    $(".sns_post_caption_contents").text(sns_post_caption);
  });


  // #########################################################################
  // report
  function updateStaffUrlAndRedirect(params, baseUrl = window.location.href) {
    let url = new URL(baseUrl);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    // start_dayおよびend_dayのパラメータがparamsに存在しない場合、これらのパラメータをURLから削除
    if (!params.start_day) {
      url.searchParams.delete('start_day');
    }
    if (!params.end_day) {
      url.searchParams.delete('end_day');
    }
    // 現在の履歴エントリに新しいURLを追加する
    history.pushState({}, '', url.toString());
    // ページをリロードする
    location.reload();
  }

  // パラメータを取得する関数
  function getStaffParameters() {
    let params = {
      staff_id: $('.staff_list_select_box option:selected').val(),
      sns_post_id: $('#staff_sns_post_selects option:selected').val(),
      device: $('.staff_device_select').data('device'),
      gf: $('#staff_graph_pattern_select_input').val(),
      start_day: $('#staff_report_start_day').val(),
      end_day: $('#staff_report_end_day').val()
    };

    params.start_day = $('#staff_report_start_day').val();
    params.end_day = $('#staff_report_end_day').val();

    // if (params.gf === '30') {
    //   params.start_day = $('#staff_report_start_day').val();
    //   params.end_day = $('#staff_report_end_day').val();
    // } else if (params.gf === '12') {
    //   delete params.start_day;
    //   delete params.end_day;
    // }

    return params;
  }

  $('#staff_sns_post_selects').on('change', function () {
    updateStaffUrlAndRedirect(getStaffParameters());
  });

  $('#staff_report_start_day, #staff_report_end_day').on('change', function () {
    updateStaffUrlAndRedirect(getStaffParameters());
  });

  $('.staff_device_select_all, .staff_device_select_pc, .staff_device_select_phone').on('click', function () {
    let params = getStaffParameters();
    if ($(this).hasClass('staff_device_select_all')) {
      params.device = '2';
    } else if ($(this).hasClass('staff_device_select_pc')) {
      params.device = '0';
    } else if ($(this).hasClass('staff_device_select_phone')) {
      params.device = '1';
    }
    updateStaffUrlAndRedirect(params);
  });

  $('.staff_graph_pattern_select_day, .staff_graph_pattern_select_month').on('click', function () {
    let params;
    if ($(this).hasClass('staff_graph_pattern_select_day')) {
      params = getStaffParameters();
      params.gf = '30';
      params.start_day = $('#staff_report_start_day').val();
      params.end_day = $('#staff_report_end_day').val();
    } else if ($(this).hasClass('staff_graph_pattern_select_month')) {
      params = getStaffParameters();
      params.gf = '12';
      params.start_day = $('#staff_report_start_day').val();
      params.end_day = $('#staff_report_end_day').val();
      // delete params.start_day;
      // delete params.end_day;
    }
    updateStaffUrlAndRedirect(params);
  });

  $('#ua_staff_group_month_selects').on('change', function () {
    let month = $('#ua_staff_group_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      location.href = 'staff_report';
    }
  });

  $('#download_staff_csv').on('click', function () {
    let href = '/download_staff_csv';
    href += `?staff_id=${$('.staff_list_select_box option:selected').val()}`;
    href += `&device=${$('.staff_device_select').data('device')}`;
    href += `&start_day=${$('#staff_report_start_day').val()}`;
    href += `&end_day=${$('#staff_report_end_day').val()}`;
    location.href = href;
  });

});
